import { LIST, GRID } from 'constants';
import {
  TTP_AMAZON_S3,
  TTP_EVENT_URL,
  TTP_EMAILING_URL,
  TTP_SURVEY_URL,
  TTP_TALK_URL,
  TTP_HOME_URL,
  TTP_BLOG_URL,
  TTP_MEDIA_URL,
  TTP_PAYMENT_URL,
  // TTP_FORUM_URL,
  TTP_WEBTOOL_URL
} from 'Config';

export const MENUS = {
  GUEST: ['HOME'],
  CONTACT: ['HOME' , 'CLIENTS'],
  USER: ['HOME', 'CAMPAIGN_LIST', 'CREATE_CAMPAIGN', 'CLIENTS'],
  ASSISTANT: ['HOME', 'CAMPAIGN_LIST', 'CREATE_CAMPAIGN', 'CLIENTS'],
  ACCOUNTANT: ['HOME', 'CAMPAIGN_LIST', 'CREATE_CAMPAIGN', 'CLIENTS'],
  ADMIN: ['HOME', 'CAMPAIGN_LIST', 'CREATE_CAMPAIGN', 'CLIENTS', 'THEMES_LIST', 'LISTS_LIST'],
};

export const STEPS = {
  'CREATE_CAMPAIGN': 'CREATE_CAMPAIGN',
  'MANAGE_THEME': 'MANAGE_THEME',
}

export const COPYRIGHT_YEAR = (new Date()).getFullYear();

export const LIST_PAGE_SIZES = [ 2, 10, 25, 50, 100];

export const CAMPAIGN_STATUS = ['DRAFT', 'SENT', 'CREATED'];

export const RECIPIENTS_STATUS = {'deliveredTo':'DELIVERED_TO', 'emailsOpen':'EMAILS_OPEN', 'linkClicks':'LINK_CLICKS', 'Bounce':'BOUNCE', 'Spam':'SPAM', 'Unsubscribe':'UNSUBSCRIBE'};

export const CAMPAIGN_TYPE = ['WEB_PAGE', 'PLAIN_TEXT'];

export const CAMPAIGN_LANGUAGE = {fr:'french', en:'english', nl:'dutch'};

export const CAMPAIGN_RECIPIENTS_TYPE = ['CONTACT', 'PROSPECT', 'SPEAKER', 'GUEST', 'PARTNER', 'MAILING_LIST'];

export const CAMPAIGN_DYNAMIC_FIELDS = [{'name':"first name", "value":"{{receiver.firstName}}"}, {'name':"last name", "value":"{{receiver.lastName}}"}];

export const RECIPIENT_ATTRIBUTE = {
  'CONTACT': {'email': 'mainEmail', 'firstName': 'firstName', 'lastName': 'lastName'},
  'PROSPECT': {'email': 'email', 'firstName': 'firstName', 'lastName': 'lastName'},
  'SPEAKER': {'email': 'compte', 'firstName': 'prenom', 'lastName': 'nom'},
  'GUEST': {'email': 'compte', 'firstName': 'prenom', 'lastName': 'nom'},
  'PARTNER': {'email': 'compte', 'firstName': null, 'lastName': 'nom'},
  'MAILING_LIST': {'email': 'email', 'firstName': 'firstName', 'lastName': 'lastName'},
};

export const PARTNER_TYPES = ['STRUCTUREL', 'EXPOSANT', 'SOUTIEN', 'MEDIA'];
export const GUEST_STATUS = [ {'id': '1', 'name': 'données personnelles'},{'id': '2', 'name': 'choix de la formule'},{'id': '3', 'name': 'données de facturation'},{'id': '4', 'name': 'paiement'},
  {'id': '5', 'name': 'confirmation'},{'id': '6', 'name': 'a reconfirmer'},{'id': '7', 'name': 'annulé'},{'id': '100', 'name': 'avec Programme'},
  {'id': '101', 'name': 'gratuits'},{'id': '102', 'name': 'payants'},{'id': '103', 'name': 'a rembourser'},{'id': '104', 'name': 'impayés'},
  {'id': '105', 'name': 'badges imprimés'},{'id': '106', 'name': 'venus'}
];

export const CLIENT = {
    sandbox:    'AeR8qh4ns8Hwqn6MiiuP2yKjbA6sCovy77mSJG6A3-MeEsdtAfpi6I6jqWlam_fBrbPDXloykqceMJID',
    production: 'AbvlDHDZzYhJ3dxd2fB8-LCrmKEn8u7WoZbMZ6uR64ZK00yT8EN0_Wc3ko2At14pNdI4zjnDPBA3LpBp',
};

export const TAMTAM_CONTACT = 'contact@tamtam.pro';
export const TAMTAM_PHONE = '0032 660 000 987';
export const BILLTOBILL = 'BilltoBill';


export const SESSION_VALIDITY_INTERVAL = 5;

export const CURRENCY = 'EUR';

export const EFFF_BIC = 'BBRUBEBB';
export const EFFF_IBAN = 'BE79 3631 8007 9833';

export const SVG_ICONS = {

  //MainMenu
  "PROFILE": "profile.svg",
  "NOTIFS": "notifs.svg",
  "APPS": "apps.svg",
  "EBOX": "ebox.svg",

  // SubMenu
  "EMAIL_LIGHT": "EMAIL-light.svg",
  "EMAIL_CREATE_LIGHT": "EMAIL-create-light.svg",
  "GENERIC_EMAIL_LIGHT": "generic-email-light.svg",
  "TEMPLATES_LIGHT": "templates-light.svg",
  "SMS_LIGHT": "SMS-light.svg",
  "SMS_CREATE_LIGHT": "SMS-create-light.svg",
  "FINANCES_SMS_LIGHT": "finances-sms-light.svg",
  "MAILBOX_LIGHT": "mailbox-light.svg",
  "OTHER_EBOX_LIGHT": "other-ebox-light.svg",

  //Page Header
  "EMAIL": "EMAIL.svg",
  "SMS": "SMS.svg",
  "SETTING": "settings.svg",
  "EDIT_EMAIL": "edit-email.svg",
  "EDIT_SMS": "SMS-create.svg",
  "FINANCES_SMS": "finances-sms.svg",
  "TEMPLATES": "templates.svg",
  "GENERIC_EMAIL": "generic-email.svg",
  "NOTIFICATIONS": "notifications.svg",
  "MAILBOX": "mailbox.svg",
  "OTHER_EBOX": "other-ebox.svg",

  //Theme actions
  "PREVIEW": "preview.svg",
  "DUPLICATE": "duplicate.svg",
  "EDIT": "edit.svg",
  "DELETE": "delete.svg",
  "SHARE": "share.svg",
  "LINK": "link.svg",
  "PLUS": "plus.svg",

  // Type Selectors
  "DRAG_DROP": "drag_drop.svg",
  "NEWSLETTER": "newsletter.svg",
  "TEXT_EDITOR": "text_editor.svg",
  "FROM_URL": "from_url.svg",

  //Others
  "TRASH": "trash.svg",
  "EYE": "eye.svg",
  "TEST": "test.svg",
  "PENCIL": "pencil.svg",
  "COPY": "copy.svg",
  "OPEN_LINK": "open-link.svg",
  "CLOSE": "close.svg"
}


export const APPS = [
  {
    url: TTP_EVENT_URL,
    name: 'Event',
    icon: `${TTP_AMAZON_S3}/apps/event.png`,
  },
  {
    url: TTP_TALK_URL,
    name: 'Talk',
    icon: `${TTP_AMAZON_S3}/apps/talk.png`,
  },
  {
    url: TTP_SURVEY_URL,
    name: 'Survey',
    icon: `${TTP_AMAZON_S3}/apps/survey.png`,
  },
  {
    url: `${TTP_EMAILING_URL}/smsCampaigns`,
    name: 'SMS',
    icon: `${TTP_AMAZON_S3}/apps/sms.png`,
  },
  {
    url: TTP_EMAILING_URL,
    name: 'E-mailing',
    icon: `${TTP_AMAZON_S3}/apps/emailing.png`,
  },
  {
    url: `${TTP_EMAILING_URL}/e_box`,
    name: 'E-box',
    icon: `${TTP_AMAZON_S3}/apps/ebox.png`,
  },
  {
    url: TTP_BLOG_URL,
    name: 'Blog',
    icon: `${TTP_AMAZON_S3}/apps/blog.png`,
  },
  {
    url: TTP_HOME_URL,
    name: 'Directory',
    icon: `${TTP_AMAZON_S3}/apps/directory.png`,
  },
  {
    url: TTP_WEBTOOL_URL,
    name: 'Webtools',
    icon: `${TTP_AMAZON_S3}/apps/webtools.png`,
  },
  {
    url: TTP_MEDIA_URL,
    name: 'Media',
    icon: `${TTP_AMAZON_S3}/apps/media.png`,
  },
  // {
  //   url: TTP_FORUM_URL,
  //   name: 'Forum',
  //   icon: `${TTP_AMAZON_S3}/apps/forum.png`,
  // },
  //  {
  //   url: TTP_PAYMENT_URL,
  //   name: 'Payment',
  //   icon: `${TTP_AMAZON_S3}/apps/payment.png`,
  // },
];

export const SORT_OPTIONS = [
  { label: 'oldest first', value: 'asc' },
  { label: 'newest first', value: 'desc' },
];

export const TTP_LOGO_URL = "/img/home/logo.svg";
export const COMMUNITY_NAME_MAX_LENGTH = 20;
export const COMMUNITY_DEFAULT_LOGO_URL = "/img/default-logo.png";



// WEBPACK FOOTER //
// ./app/config/Common.js